'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var React = require('react');
var reactRouterDom = require('react-router-dom');
var PageCanvas_module = require('./PageCanvas.module.scss.js');
var PermissionsContext = require('../Permissions/PermissionsContext.js');
require('../Permissions/PermissionsProvider.js');
require('../Permissions/Restriction.js');
var PageCanvasMenu = require('./PageCanvasMenu.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PageToRenderIndexComparator = (a, b) => a.index - b.index;
const getPageFromChild = (child, index) => {
    const page = child;
    const { name, path, application, permission } = page.props;
    return {
        name,
        path,
        component: page.props.children,
        index,
        application,
        permission,
    };
};
const PageCanvasLayout = ({ menuItems }) => (React__default["default"].createElement("div", { className: PageCanvas_module["default"].PageCanvasContainer },
    React__default["default"].createElement("div", { className: PageCanvas_module["default"].PageCanvasMenu },
        React__default["default"].createElement(PageCanvasMenu["default"], { items: menuItems, isCurrentItem: (selectedItem, item) => selectedItem.endsWith(item.url) })),
    React__default["default"].createElement("div", { className: PageCanvas_module["default"].PageCanvasContent },
        React__default["default"].createElement(reactRouterDom.Outlet, null))));
const PageCanvas = ({ children }) => {
    const { isAllowed } = React.useContext(PermissionsContext["default"]);
    const [pagesToRender, setPagesToRender] = React.useState([]);
    React.useEffect(() => {
        const buildPromiseForRestrictedPage = (newPage) => _tslib.__awaiter(void 0, void 0, void 0, function* () {
            if (newPage.application !== undefined && newPage.permission !== undefined) {
                if (!(yield isAllowed(newPage.application, newPage.permission))) {
                    return null;
                }
            }
            return newPage;
        });
        const loadPages = () => _tslib.__awaiter(void 0, void 0, void 0, function* () {
            const pagesToCheck = [];
            React.Children.forEach(children, (child, index) => {
                const newPage = getPageFromChild(child, index);
                pagesToCheck.push(buildPromiseForRestrictedPage(newPage));
            });
            return Promise.all(pagesToCheck);
        });
        loadPages().then((pages) => {
            const filteredPages = pages.filter((p) => p !== null);
            setPagesToRender(filteredPages);
        });
    }, [children, isAllowed]);
    function submenuItems(url) {
        const items = [];
        pagesToRender.forEach((pageToRender) => {
            const { name, path } = pageToRender;
            const regExpMatchArray = path.match(`${url}\\/[^\\/]*$`);
            if (regExpMatchArray != null && regExpMatchArray.index === 0) {
                items.push({
                    label: name,
                    url: path,
                    component: React__default["default"].createElement(reactRouterDom.Link, { to: path }, name),
                    children: submenuItems(path),
                });
            }
        });
        return items;
    }
    const menuItems = [...pagesToRender]
        .filter((page) => !page.path.match('.*\\/.*'))
        .sort(PageToRenderIndexComparator)
        .map((p) => {
        const label = p.name;
        const url = `${p.path}`;
        return {
            label,
            url,
            children: submenuItems(url),
            component: React__default["default"].createElement(reactRouterDom.Link, { to: url }, label),
        };
    });
    return (React__default["default"].createElement(reactRouterDom.Routes, null,
        React__default["default"].createElement(reactRouterDom.Route, { path: "/", element: React__default["default"].createElement(PageCanvasLayout, { menuItems: menuItems }) },
            menuItems.length > 0 && (React__default["default"].createElement(reactRouterDom.Route, { path: "/", element: React__default["default"].createElement(reactRouterDom.Navigate, { to: pagesToRender[0].path, replace: true }) })),
            menuItems.length > 0 &&
                pagesToRender.map((p) => (React__default["default"].createElement(reactRouterDom.Route, { key: p.path, path: p.path, element: p.component }))))));
};

exports["default"] = PageCanvas;
